export type LoginData = {
  email: string;
  password: string;
};

export type LoginAsData = {
  targetUserId: string;
};

export type PageSizeType = 10 | 20 | 50 | 100;

export type UserRolesType =
  | "Admin" //Админ. DMS SKAD
  | "Manager" // Менеджер SKAD
  | "Marketer" // Маркетолог SKAD Просмотр отчетности по всем диллерам, номенклатура, остатки
  | "Dealer" // Админ диллера. Может создавать менеджеров диллера и назначать на роль админа
  | "Sales" /// Менеджер диллера(продавец) <summary>
  | "TechAdmin" /// Технический администратор <summary>
  | "ApiDealer"; /// Api Дилер <summary>

export enum UserRolesEnum {
  "Admin" = "Администратор СКАД",
  "Dealer" = "Администратор",
  "Manager" = "Менеджер СКАД",
  "Marketer" = "Маркетолог",
  "Sales" = "Менеджер ",
  "TechAdmin" = "Технический администратор",
  "ApiDealer" = "API",
}

export interface IApiError {
  title: string;
  status: number;
  detail: string;
  instance?: string;
}
